import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pointsrule" }

import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { PointsRuleSpe } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<PointsRuleSpe>({
  localToPoints: '',
  localToCoins: '',
  limitPoints: '',
});

// 正数正则（可保留2位小数）
const positiveNumberPattern = /^\d+:\d+$/u;

const rules: FormRules = {
  localToPoints: [
    { required: true, message: '请输入本地到积分比例', trigger: 'change' },
    { pattern: positiveNumberPattern, message: '请输入正确的比例，格式为：x:x', trigger: 'change' },
  ],
  localToCoins: [
    { required: true, message: '请输入本地到D币比例', trigger: 'change' },
    { pattern: positiveNumberPattern, message: '请输入正确的比例，格式为：x:x', trigger: 'change' },
  ],
  limitPoints: [
    { required: true, message: '请输入积分上限', trigger: 'change' },
    { pattern: /^\d+$/u, message: '请输入正整数', trigger: 'change' },
  ],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().pointsRuleApi.getPointsRulepointsRule();
    const { data } = res.data;
    if (data) {
      formData.localToPoints = data.localToPoints || '';
      formData.localToCoins = data.localToCoins || '';
      formData.limitPoints = data.limitPoints || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().pointsRuleApi.setPointsRulepointsRule({
      rule: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().pointsRuleApi.resetPointsRulepointsRule();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-width": "300px",
      class: "config-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "1:1兑换积分上限",
          prop: "limitPoints"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.limitPoints,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.limitPoints) = $event)),
              placeholder: "请输入积分上限"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "超过部分兑换积分比例（本地积分：积分）",
          prop: "localToPoints"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.localToPoints,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.localToPoints) = $event)),
              placeholder: "请输入本地积分到积分比例"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "超过部分兑换D币比例（本地积分：D币）",
          prop: "localToCoins"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.localToCoins,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.localToCoins) = $event)),
              placeholder: "请输入本地积分到D币比例"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSave),
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" 保存配置 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: handleReset,
              loading: resetting.value
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" 重置为默认 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})